const sound = {
  state: () => ({
    editData: {},
    showFirstTimeEditDataForSound: true
  }),

  getters: {
    editData(state) {
      return state.editData;
    },
    showFirstTimeEditDataForSound(state) {
      return state.showFirstTimeEditDataForSound;
    }
  },

  mutations: {
    saveEditSound(state, data) {
      state.editData = data;
    },
    removeFirstTimeEditDataForSound(state) {
      state.showFirstTimeEditDataForSound = false;
    },
    showFirstTimeEditDataForSound(state) {
      state.showFirstTimeEditDataForSound = true;
    }
  }
};

export default sound;
